import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { pages, WaiverSteps } from 'src/app/alv-enums';
import { StoreService } from 'src/app/services/store.service';
import { WaiverService } from 'src/app/services/waiver.service';
import { Guest, ContactInfo, GuestBase } from 'src/app/models/waiver';
import { ToolsService } from 'src/app/services/tools.service';
import { Utility } from 'src/app/common/utility';

@Component({
	selector: 'email-info',
	encapsulation: ViewEncapsulation.None,
	templateUrl: './email-info.component.html',
	styleUrls: ['./email-info.component.scss']
})
export class EmailInfoComponent implements OnInit {
	months: string[] = ["Jan", "Feb", "Mar", "Apr", "May", "June", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
	
	// Custom validation properties
	public emailValid: boolean = true;
	public emailErrorMessage: string = '';

	constructor(public storeService: StoreService, public waiverService: WaiverService, public toolsService: ToolsService) { }
	ngOnInit() {
	}
	goToStep(step: WaiverSteps) {
		const self = this;
		//go to next step password
		self.waiverService.onStepChangeForward(step);
	}
	emailChange() {

	}

	// Custom email validation function
	validateEmail(emailAddress: string): boolean {
		// Check for non-ASCII characters
		for (let i = 0; i < emailAddress.length; i++) {
			if (emailAddress[i].charCodeAt(i) > 127) {
				return false;
			}

			continue;
		}

		const pattern = /^[a-zA-Z0-9]([a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (!(pattern.test(emailAddress))) {
			return false;
		};

		if (emailAddress.length > 254) {
			return false;
		}

		const atIndex = emailAddress.indexOf('@');
		if (atIndex <= 0 || atIndex === emailAddress.length - 1) {
			return false;
		}

		const localPart = emailAddress.substring(0, atIndex);
		const domain = emailAddress.substring(atIndex + 1);

		if (localPart.length > 64 || localPart[0] === '.' || localPart[localPart.length - 1] === '.') {
			return false;
		}
		if (domain[0] === '.' || domain[domain.length - 1] === '.' || domain[0] === '-' || domain[domain.length - 1] === '-') {
			return false;
		}

		// Check each domain label doesn't start or end with hyphen
		let start = 0;
		for (let i = 0; i <= domain.length; i++) {
			if (i === domain.length || domain[i] === '.') {
				if (i > start) {
					const label = domain.substring(start, i);
					if (label[0] === '-' || label[label.length - 1] === '-') {
						return false;
					}
				}
				start = i + 1;
			}
		}

		if (emailAddress.includes("..")) {
			return false;
		}
		return true;
	}

	onEmailChange(emailValue: string) {
		if (!emailValue || emailValue.trim() === '') {
			this.emailValid = true; 
			this.emailErrorMessage = '';
		} else {
			this.emailValid = this.validateEmail(emailValue);
			this.emailErrorMessage = this.emailValid ? '' : 'Please enter a valid email address';
		}
	}

	onEmailBlur(emailValue: string) {
		const trimmedValue = emailValue.trim();
		this.storeService.waiver.email = trimmedValue;
		this.onEmailChange(trimmedValue);
	}
	lookUpGuests() {
		let self = this;
		self.storeService.waiver.guests = [];
		self.waiverService.LookupGuestList(self.storeService.waiver.signee.guestAccountId, self.storeService.waiver.waiverId)
			.then(response => {
				this.toolsService.ProcessHttpResponse(response, () => {
					let list = response.data;
					if (list && list.length > 0) {
						list.forEach(guestData => {
							var guest = new GuestBase();
							guest.basicInfo.firstName = guestData.firstName;
							guest.basicInfo.lastName = guestData.lastName;
							guest.basicInfo.bDate = guestData.birthDate && new Date(guestData.birthDate).getDate();
							guest.basicInfo.bMonth = guestData.birthDate && new Date(guestData.birthDate).getMonth();
							guest.basicInfo.bYear = guestData.birthDate && new Date(guestData.birthDate).getFullYear();
							let bDate = new Date(guestData.birthDate)
							guest.basicInfo.birthDate = bDate;
							guest.basicInfo.IsMinor = guestData.birthDate && (Utility.calculateAge(bDate) <= +(this.storeService.waiver.minAgeOfConsent))
							guest.guestId = guestData.guestId;
							guest.exists = true;
							guest.waiverInfo.hasCurrentWaiver = guestData.hasCurrentWaiver;
							if (guestData.hasCurrentWaiver == true && guestData.currentWaiverExpirationDate) {
								guest.waiverInfo.waiverStatus = `valid thr ${new Date(guestData.currentWaiverExpirationDate).getDate()} ${this.months[new Date(guestData.currentWaiverExpirationDate).getMonth()]} ${new Date(guestData.currentWaiverExpirationDate).getFullYear()}`
							}
							else {
								guest.waiverInfo.waiverStatus = 'No Current Waiver'
							}
							self.storeService.waiver.guests.push(guest);
						});
					}
					this.calculateNextStepAndGo();
				})
			});
	}
	onSubmit() {

		const self = this;
		
		const emailValue = this.storeService.waiver.email;
		if (emailValue && emailValue.trim() !== '') {
			this.onEmailChange(emailValue);
			if (!this.emailValid) {
				return; 
			}
		}
		
		this.storeService.shoppingCart.guestEmail = this.storeService.waiver.email;
		//email changed reset test data
		self.storeService.waiver.guests = [];
		self.storeService.waiver.signee = new Guest();
		//guest look up and found
		this.waiverService.lookupGuestAccountByEmail(this.storeService.waiver.email)
			.then(response => {
				this.toolsService.ProcessHttpResponse(response, () => {
					const signee = response.data.guestAccount;
					//email look up found
					if (signee) {

						this.storeService.waiver.signee = new Guest();
						let guest = this.storeService.waiver.signee;
						guest.basicInfo.firstName = signee.firstName;
						guest.basicInfo.lastName = signee.lastName;
						guest.basicInfo.IsMinor = false; //signee is always an adult
						guest.basicInfo.bDate = signee.birthDate && new Date(signee.birthDate).getDate();
						guest.basicInfo.bMonth = signee.birthDate && new Date(signee.birthDate).getMonth();
						guest.basicInfo.bYear = signee.birthDate && new Date(signee.birthDate).getFullYear();
						guest.guestAccountId = signee.guestAccountId;
						guest.guestId = signee.guestId;
						this.storeService.shoppingCart.guestId = guest.guestId;
						guest.exists = true;
						guest.contactInfo = new ContactInfo();
						guest.contactInfo.city = signee.city;
						guest.contactInfo.phone = signee.primaryPhone;;
						guest.contactInfo.state = signee.state;
						guest.contactInfo.streetAddress = signee.streetAddress1;
						guest.contactInfo.streetAddress2 = signee.streetAddress2;
						guest.contactInfo.zipCode = signee.zipCode;
						this.storeService.waiver.requirePasswordToLoadGuestData = response.data.requirePasswordToLoadGuestData;
						this.lookUpGuests();
					}
					//guest not found
					else {
						this.goToStep(WaiverSteps.addGuests);
					}
				}), error => {
				}
			})
		window.scroll(0, 0)
	}
	calculateNextStepAndGo() {
		this.storeService.shoppingCart.guestEmail = this.storeService.waiver.email;
		if (this.storeService.waiver && this.storeService.waiver.signee && this.storeService.waiver.signee.guestAccountId > 0) {
			if (this.storeService.waiver.requirePasswordToLoadGuestData) {
				this.goToStep(WaiverSteps.password);
			}
			//does not require password verification, skip directly to guest selection
			else {
				this.goToStep(WaiverSteps.guestSelection);
			}
		}
		//guest not found
		else {
			this.goToStep(WaiverSteps.addGuests);
		}
		window.scroll(0, 0)
	}
}

